module.exports = __webpack_public_path__ + "static/media/weningsih-handout.f34a6390.pdf";